import { render, staticRenderFns } from "./RoomGuestsRepartition.vue?vue&type=template&id=2517b42e&scoped=true"
import script from "./RoomGuestsRepartition.vue?vue&type=script&lang=js"
export * from "./RoomGuestsRepartition.vue?vue&type=script&lang=js"
import style0 from "./RoomGuestsRepartition.vue?vue&type=style&index=0&id=2517b42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517b42e",
  null
  
)

export default component.exports